module.exports = __webpack_public_path__ + "img/personal_resources_time.60488fcc.svg";